"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConnection = void 0;
var react_1 = require("react");
var _1 = require(".");
exports.useConnection = function (scheme, host, port, username, password) {
    var context = react_1.useContext(_1.Neo4jContext);
    context.updateConnection({
        scheme: scheme,
        host: host,
        port: port,
        username: username,
        password: password,
    });
};
